import { IMerchant } from "@interfaces";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { useEffect } from "react";

export default function MemberTier({
    merchant,
    currentIndex,
}: {
    merchant: IMerchant;
    currentIndex: number;
}) {
    //Consider fixing later https://github.com/framer/motion/issues/2554
    // const [isMounted, setIsMount] = useState(false);
    // const [key, setKey] = useState(0);

    useEffect(() => {
        // if (!isMounted) setIsMount(true);
        // if (isMounted) setKey(key + 1);
    }, [merchant?._id, currentIndex]);

    return (
        <div
            style={{
                position: "relative",
                height: "35px",
            }}
        >
            <LazyMotion features={domAnimation}>
                <AnimatePresence>
                    <m.div
                        key={currentIndex}
                        className="topic-detail-card"
                        variants={animation}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                    >
                        {merchant?.memberShipTiers?.[currentIndex]?.membershipName}{" "}
                        <span>({merchant?.memberShipTiers?.[currentIndex]?.benefits.length})</span>
                    </m.div>
                </AnimatePresence>
            </LazyMotion>
        </div>
    );
}

const animation = {
    initial: {
        opacity: 0,
        y: 60,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 20,
            // y: { type: "tween", duration: 0.7, ease: [0.1, 1, 0.5, 0.95] },
        },
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 20,
            // y: { type: "tween", duration: 0.7, ease: [0.1, 1, 0.5, 0.95] },
        },
    },
    exit: {
        opacity: 0,
        y: 0,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 20,
        },
    },
};
